import axios from 'axios';
import { 
    formatDate, 
    isMoreThanGivenTimeDiff,
    getClosestDateToNow,
} from './utils';
import { translate } from './translations';
import {
    EST_CEL,
    TEMP,
    TEMP_MAX,
    TEMP_MIN,
    TEMP_XAF,
    PREC_ACU,
    PROB_PREC,
    HUM_REL,
    VENT_DIR,
    VENT_VELO,
} from './variables';

import {
    URL_MAPA_PREDICCIO,
    URL_PREDICCIO_COMARQUES,
    URL_RADAR,
    URL_MUNICIPIS,
    URL_AVISOS,
    URL_EST_CEL,
    URL_TEMP,
    URL_TEMP_MAX,
    URL_TEMP_MIN,
    URL_TEMP_XAF,
    URL_PREC_ACU,
    URL_PROB_PREC,
    URL_HUM_REL,
    URL_VENT_DIR,
    URL_VENT_VELO,
    ARAMET_API_CONFIG,
} from './urls';

import { getEnvironment } from '../config/environment';

const { JSON_URL, BASE_URL } = getEnvironment();
const baseUrlJson = JSON_URL;
export const baseUrl = BASE_URL;


//per processar les dades ARAMET
const dataProcessors = {
    cataleg: (data) => {
        const cel = data.filter(element => element.nom === 'cel');
        return cel.length > 0 ? cel[0].valors : [];
    },
    municipis: (data) => data.municipis,
    direct: (data) => data
};


export default class API {
    static getJson = async (path, cancelToken) => {
        return axios.get(`${baseUrlJson}${path}`, { cancelToken });
    };

    static fetchAPI = (url) => fetch(url).then(res => res.json());


    static getAramet = async cancelToken => {

        let dataAramet = {};
        let datesDades = [];
        const timeDiff = 2 * 60 * 60 * 1000; // 2 hores

        try {
            
            const results = await Promise.allSettled(
                ARAMET_API_CONFIG.map( config =>  API.fetchAPI(config.url) )
            );
            
            
            results.forEach((result, index) => {

                const config = ARAMET_API_CONFIG[index];         
                
                
                /*
                if(Object.hasOwn(result.value, 'httpStatus')){
                    console.log('entro1')
                    dataAramet[config.name] = [];
                }else{
                */

                    if(result.status === 'fulfilled'){
                        try {                               


                            //separem cataleg i capitals pq no ens interessa la seva hora de sortida
                            if(config.name !== 'cataleg' && config.name !== 'capitals'){

                                let outDate = null;
                                const value = result.value;
                                if (value && typeof value === 'object' && !Array.isArray(value)) {
                                    outDate = value.dataSortida || null;
                                } else if (Array.isArray(value)) {
                                    const firstWithDate = value.find(function (item) {
                                        return item && item.dataSortida;
                                    });
                                    outDate = firstWithDate ? firstWithDate.dataSortida : null;
                                }
                                
                                //mirem si hi ha una diferència de més de 2 hores (2*60*60*1000) 
                                if(isMoreThanGivenTimeDiff(timeDiff, outDate)){
                                    //si tenim més de dues hores de diferència no posem dades
                                    dataAramet[config.name] = [];
                                }else{
                                    if(outDate !== null) datesDades.push(outDate);
                                    dataAramet[config.name] = dataProcessors[config.processor](result.value);
                                }
                            }else{
                                dataAramet[config.name] = dataProcessors[config.processor](result.value);
                            }                           
                           
                        } catch (error) {
                            dataAramet[config.name] = [];
                            console.log(`Error processing ${config.name}:`, error);
                        }
                    }else{
                       
                        dataAramet[config.name] = [];
                        console.log(` Failed to fetch ${config.name}:`, result.reason);
                    }

                //} 
                
            });

            
            const closestDate = getClosestDateToNow(datesDades);
            dataAramet['dataSortida'] = closestDate;
           
            return dataAramet;

        } catch (error) {
            console.log(' Error in fetchAllData:', error);
            return dataAramet;
        }       

        
    };



    static getCatalunya3 = async cancelToken => {

        
        let today = new Date();
        
        const day1 = API.getJson(
            URL_MAPA_PREDICCIO.replace('{DATE}', formatDate(today)),
            cancelToken
        );
        today.setDate(today.getDate() + 1);
        
        const day2 = API.getJson(
            URL_MAPA_PREDICCIO.replace('{DATE}', formatDate(today)),
            cancelToken
        );
        
        today.setDate(today.getDate() + 1);
        const day3 = API.getJson(
            URL_MAPA_PREDICCIO.replace('{DATE}', formatDate(today)),
            cancelToken
        ).catch(error => {
            if (error.response.status === 404 /*|| error.response.status === 403*/) {
                return '';
            }
        });

        today = new Date();
        const day1_comarques = API.getJson(
            URL_PREDICCIO_COMARQUES.replace('{DATE}', formatDate(today)),
            cancelToken
        );
        today.setDate(today.getDate() + 1);
        const day2_comarques = API.getJson(
            URL_PREDICCIO_COMARQUES.replace('{DATE}', formatDate(today)),
            cancelToken
        );
        today.setDate(today.getDate() + 1);
        const day3_comarques = API.getJson(
            URL_PREDICCIO_COMARQUES.replace('{DATE}', formatDate(today)),
            cancelToken
        ).catch(error => {
            if (error.response.status === 404 /*|| error.response.status === 403*/) {
                return '';
            }
        });

        return Promise.all([
            day1,
            day2,
            day3,
            day1_comarques,
            day2_comarques,
            day3_comarques,
        ]);
    };


    static getRadar = async cancelToken => {
        return API.getJson(URL_RADAR, cancelToken);
    };

    static getMunicipis = async cancelToken => {
        return API.getJson(URL_MUNICIPIS, cancelToken);
    };

    static getAvisos = async cancelToken => {
        var today = new Date();
        const day1 = API.getJson(
            URL_AVISOS.replace('{DATE}', formatDate(today)),
            cancelToken
        ).catch(error => {
            if (error.response.status === 404 /*|| error.response.status === 403*/) {
                return '';
            }
        });
        today.setDate(today.getDate() + 1);
        const day2 = API.getJson(
            URL_AVISOS.replace('{DATE}', formatDate(today)),
            cancelToken
        ).catch(error => {
            if (error.response.status === 404 /*|| error.response.status === 403*/) {
                return '';
            }
        });
        today.setDate(today.getDate() + 1);
        const day3 = API.getJson(
            URL_AVISOS.replace('{DATE}', formatDate(today)),
            cancelToken
        ).catch(error => {
            if (error.response.status === 404 /*|| error.response.status === 403*/) {
                return '';
            }
        });
        return Promise.all([day1, day2, day3]);
    };

    static getMunicipal72h = async (config, cancelToken) => {
        var promises = [];
        config.variables.forEach(el => {
            try {
                let info_variable = API.getVariable(
                    el,
                    1,
                    3,
                    config.language,
                    cancelToken
                );
                promises = promises.concat(info_variable);
            } catch (e) {
                //TODO improve error handling
                console.log(e);
            }
        });

        return Promise.all(promises);
    };

    static getMunicipal8d = async (config, cancelToken) => {
        var promises = [];
        config.variables.forEach(el => {
            try {
                let info_variable = API.getVariable(
                    el,
                    24,
                    8,
                    config.language,
                    cancelToken
                );
                promises = promises.concat(info_variable);
            } catch (e) {
                //TODO improve error handling
                console.log(e);
            }
        });

        return Promise.all(promises);
    };

    static getVariable = (
        variable,
        interval,
        numDays,
        language,
        cancelToken
    ) => {
        var url = '';
        switch (variable) {
            case EST_CEL:
                url = URL_EST_CEL;
                break;
            case TEMP:
                url = URL_TEMP;
                break;
            case TEMP_MAX:
                url = URL_TEMP_MAX;
                break;
            case TEMP_MIN:
                url = URL_TEMP_MIN;
                break;
            case TEMP_XAF:
                url = URL_TEMP_XAF;
                break;
            case PREC_ACU:
                url = URL_PREC_ACU;
                break;
            case PROB_PREC:
                url = URL_PROB_PREC;
                break;
            case HUM_REL:
                url = URL_HUM_REL;
                break;
            case VENT_DIR:
                url = URL_VENT_DIR;
                break;
            case VENT_VELO:
                url = URL_VENT_VELO;
                break;
            default:
                throw new Error(translate(language, 'unknown_variable'));
        }

        url = url.replace(/{INTERVAL}/gi, interval);
        let promises = [];
        for (let i = 1; i <= numDays; i++) {
            let variable_url = url.replace(/{DAY}/gi, i);
            promises.push(API.getJson(variable_url, cancelToken));
        }
        return promises;
    };
}



// WEBPACK FOOTER //
// ./src/utils/api.js